import React from 'react'

import { getDurationText } from './helpers'
import * as S from './styles'

import type { DatePickerLabelProps } from './types'
import type { FC } from 'react'

export const Label: FC<DatePickerLabelProps> = ({ name, start, end }) => {
  const showDuration = start && end
  const durationText = getDurationText(start, end)

  return (
    <S.LabelContainer>
      {name}
      {showDuration && <S.Duration>{durationText}</S.Duration>}
    </S.LabelContainer>
  )
}
